const SORT_DIRECTION = {
  ASC: "ASC",
  DESC: "DESC",
};

export default SORT_DIRECTION;
